import defaultState from "./state";
const initialState = { ...defaultState };

const PrestacionEmpresaReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "RESET_STATE_PRESTACIONES_EMPRESA": {
      return Object.assign({}, state, initialState);
    }
    case "LOADING_PRESTACIONES_EMPRESA": {
      return Object.assign({}, state, {
        isLoading: action.isLoading,
      });
    }
    case "LOADING_PRESTACIONES_DOWNLOAD_EXCEL": {
      return Object.assign({}, state, {
        isDownloadLoading: action.isDownloadLoading,
      });
    }
    case "SET_TIPO_PRESTACION": {
      return Object.assign({}, state, {
        selectedTipoPrestacion: action.tipo,
      });
    }

    case "SET_MAIN_FILTER_SELECTED": {
      const itemSelected = action.payload;
      return {...state, selectedTipoPrestacion: itemSelected};
    }

    case "SET_PRESTACIONES_EMPRESA": {
      return Object.assign({}, state, {
        listaPrestaciones: action.listaPrestaciones,
        totalPrestaciones: action.total,
      });
    }
    case "SET_SHOW_NO_DATA": {
      return Object.assign({}, state, {
        showNoData: action.showNoData,
      });
    }
    case "SET_PRESTACIONES_EMPRESAS_FILTRADAS": {
      return Object.assign({}, state, {
        listaPrestacionesFiltrada: action.listaPrestacionesFiltrada,
      });
    }
    case "SET_PRESTACIONES_FILTERS": {
      return Object.assign({}, state, {
        filtrosPrestaciones: action.filtros,
      });
    }
    case "OPEN_CLOSE_MODAL_BORRADOR_PE": {
      return Object.assign({}, state, {
        isOpenModalBorrador: action.isOpen,
      });
    }
    case "EDITING_DRAFT_PE": {
      return Object.assign({}, state, {
        editingDraft: action.editing,
      });
    }
    case "OPEN_CLOSE_MODAL_CONTINUE": {
      return Object.assign({}, state, {
        isOpenModalContinue: action.isOpen,
      });
    }
    case "OPEN_CLOSE_MODAL_DELETE": {
      return Object.assign({}, state, {
        isOpenModalDelete: action.isOpen,
      });
    }

    case "SET_CLEAN_DATA_DRAFT": {
      return Object.assign({}, state, {
        isModified: false,
        isOpenModalBorrador: false,
        lastCompletedStep: 1,
        activeStep: 1,
        lastStep: 4,
        editingDraft: false,
        IdDraft: null,
        jsonData: {
          Id: null,
          idFinancialBenefit: null,
          monthsDisplay: [],

          middleStepsEnabled: true,
          fechaSiniestro: null,
          formInfoTrabajador: {},
          formInfoLaboral: {},
          formInfoPrevisional: {
            checkAllMonth: false,
          },
          formEnvioDocumento: {},
          currentStep: 1,
          step1Complete: false,
          step2Complete: false,
          step3Complete: false,
          step4Complete: false,
          container: null,
        },
      });
    }

    case "SET_SHOWHIDE_FORM_PE": {
      const actualState = { ...state };
      if (!action.showHideForm) actualState.activeStep = 1;
      return Object.assign({}, state, {
        showHideForm: action.showHideForm,
        activeStep: actualState.activeStep,
      });
    }
    case "SET_STEP_PE": {
      let maxStep = state.lastCompletedStep;
      if (action.step > state.lastCompletedStep) maxStep = action.step;
      return Object.assign({}, state, {
        activeStep: action.step,
        lastCompletedStep: maxStep,
      });
    }
    case "NEXT_STEP_PE": {
      const middleStepsEnabled = state.jsonData.middleStepsEnabled;
      // const nextStep = middleStepsEnabled === false ? state.lastStep : state.activeStep + 1;
      const nextStep = state.activeStep;

      return Object.assign({}, state, {
        activeStep: nextStep,
        lastCompletedStep: nextStep > state.lastCompletedStep ? nextStep : state.lastCompletedStep,
      });
    }
    case "LAST_STEP_PE": {
      const middleStepsEnabled = state.jsonData.middleStepsEnabled;
      // const backStep = middleStepsEnabled === false ? 1 : state.activeStep - 1;
      const backStep = state.activeStep;

      return Object.assign({}, state, {
        activeStep: backStep,
      });
    }

    case "SET_LISTA_PRESTACION_FROM_BORRADOR": {

      const dato = state.listaPrestacionesFiltrada.find(x => x.IdSiniestro === action.jsonData.idSiniestro && (x.IdPrestacion === action.jsonData.idFinancialBenefit || x.IdPrestacion === null));
      const index = state.listaPrestacionesFiltrada.findIndex(x => x === dato);

      const datoGeneral = state.listaPrestaciones.find(x => x === dato);
      const indexGeneral = state.listaPrestaciones.findIndex(x => x === datoGeneral);

      const rowGeneral = Object.assign({}, datoGeneral, { EstadoDocumentacion: 'Borrador' });
      const row = Object.assign({}, dato, { EstadoDocumentacion: 'Borrador' });

      return Object.assign({}, state, {
        listaPrestacionesFiltrada: [...state.listaPrestacionesFiltrada.slice(0, index),
        {
          ...row
        },

        ...state.listaPrestacionesFiltrada.slice(index + 1)],
        listaPrestaciones: [...state.listaPrestaciones.slice(0, indexGeneral),
        {
          ...rowGeneral
        },
        ...state.listaPrestacionesFiltrada.slice(indexGeneral + 1)]
      });
    }


    case "SET_JSON_DATA_PE": {
      return Object.assign({}, state, {
        jsonData: action.jsonData,
        isModified: true,
      });
    }
    case "SET_DRAFT_PE": {
      return Object.assign({}, state, {
        jsonData: action.jsonData,
        lastCompletedStep: action.jsonData.lastCompletedStep,
      });
    }
    case "SET_ID_DRAFT_PE": {
      return Object.assign({}, state, {
        IdDraft: action.IdDraft,
      });
    }
    case "SET_DOCUMENT_LIST": {
      return Object.assign({}, state, {
        listaDocumentosIngresados: action.listaDocumentosIngresados,
      });
    }
    case "SET_MAIN_FILTERS": {
      return Object.assign({}, state, {
        mainFilters: action.mainFilters,
      });
    }

    default:
      return state;
  }
};

export default PrestacionEmpresaReducer;
